"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const SnackbarContent_1 = __importDefault(require("@material-ui/core/SnackbarContent"));
const classnames_1 = __importDefault(require("classnames"));
const helpers_1 = require("@material-ui/core/utils/helpers");
const palette_1 = __importDefault(require("../Picasso/config/palette"));
const Icon_1 = require("../Icon");
const Container_1 = __importDefault(require("../Container"));
const Button_1 = __importDefault(require("../Button"));
const styles_2 = __importDefault(require("./styles"));
const Typography_1 = __importDefault(require("../Typography"));
const renderNotificationCloseButton = ({ onClose, classes: { close, closeIcon } }) => (react_1.default.createElement(Button_1.default, { circular: true, onClick: onClose, className: close, title: 'Close Notification', icon: react_1.default.createElement(Icon_1.Close, { className: closeIcon, size: 0.8 }) }));
const renderNotificationIcon = ({ icon, variant, classes }) => {
    const iconProps = {
        className: classes.icon,
        size: 1.25
    };
    // TODO: these are Icons required circular Icon bg color definitions, all Icons should be white on that color
    // Missing the following: https://github.com/toptal/picasso/issues/253
    switch (variant) {
        case 'error':
            // eslint-disable-next-line react/jsx-props-no-spreading
            return react_1.default.createElement(Icon_1.Alert, Object.assign({}, iconProps, { color: palette_1.default.error.main }));
        case 'warning':
            // eslint-disable-next-line react/jsx-props-no-spreading
            return react_1.default.createElement(Icon_1.Alert, Object.assign({}, iconProps, { color: palette_1.default.warning.main }));
        case 'success':
            // eslint-disable-next-line react/jsx-props-no-spreading
            return react_1.default.createElement(Icon_1.Tick, Object.assign({}, iconProps, { color: palette_1.default.success.main }));
        default:
            const infoProps = Object.assign({}, iconProps, { color: palette_1.default.grey[200] });
            // eslint-disable-next-line react/jsx-props-no-spreading
            return icon ? react_1.cloneElement(icon, infoProps) : react_1.default.createElement(Icon_1.Info, Object.assign({}, infoProps));
    }
};
const renderNotificationContent = (props) => {
    const { classes: { iconWrapper, content, contentCloseButton }, children, onClose } = props;
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(Container_1.default, { flex: true, alignItems: 'center', className: iconWrapper }, renderNotificationIcon(props)),
        react_1.default.createElement(Typography_1.default, { className: classnames_1.default(content, {
                [contentCloseButton]: onClose
            }), variant: 'small', as: 'div' }, children),
        onClose && renderNotificationCloseButton(props)));
};
exports.Notification = props => {
    const { className, classes, variant, elevated, fullWidth } = props;
    return (react_1.default.createElement(SnackbarContent_1.default, { className: classnames_1.default(classes[`notification${helpers_1.capitalize(variant)}`], {
            [classes.notificationShadow]: elevated,
            [classes.notificationFullWidth]: fullWidth
        }, classes.notification, className), message: renderNotificationContent(props) }));
};
exports.Notification.defaultProps = {
    elevated: false,
    fullWidth: false,
    variant: 'info'
};
exports.Notification.displayName = 'Notification';
exports.default = styles_1.withStyles(styles_2.default)(exports.Notification);
//# sourceMappingURL=Notification.js.map